class LaunchDarklyService {
  // Returns the identify() promise so callers that need flags resolved against the real user
  // context (not the anonymous pre-identify context) can await it before reading a flag value.
  static configureUser = (ldClient, user) => {
    if (!ldClient || !user?.id) return undefined;

    // v3.x+ uses Contexts: https://docs-stg.launchdarkly.com/contexts-eap/home/contexts
    const context = {
      category: user.category,
      companyName: user.company?.name,
      email: user.email,
      firstName: user.first_name,
      isBidopsTeamUser: user.is_bidops_team_user,
      isSelfServe: user.is_self_serve,
      key: user.id,
      kind: 'user',
      lastName: user.last_name,
      name: user.displayname,
      planType: user.plan_type,
      role: user.role,
      subdomain: user.subdomain,
      trueUserEmail: user.true_user?.email,
      trueUserId: user.true_user?.id
    };

    // Attach user to launch darkly
    return ldClient.identify(context);
  };
}

export default LaunchDarklyService;
